// src/utils/api.js
import axios from "axios";

console.log("API URL:", process.env.REACT_APP_API_URL);


const api = axios.create({
  baseURL: (process.env.REACT_APP_API_URL) + "/api",
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
